<template>
    <label
        :class="{ [`form-${type}`]: true, [`input-${size}`]: true }"
    >
        <input
            v-bind="input_props"
            :type="input_type"
            v-on="$listeners"
        />
        <i class="form-icon"></i><slot></slot>
    </label>
</template>

<script>
export default {
    name: "BaseToggleInput",
    computed: {
        input_props () {
            return {
                id: this.id,
                name: this.name,
                checked: this.checked,
                disabled: this.disabled
            }
        },
        input_type () {
            if(this.type === "switch") return "checkbox"
            return this.type
        }
    },
    props: {
        id: {
            type: String,
            validator: prop => !!prop
        },
        name: {
            type: String,
            validator: prop => !!prop,
            required: true
        },
        checked: {
            default: false
        },
        type: {
            type: String,
            validator: prop => !!prop && !!prop.match(/^(radio|checkbox|switch)$/i),
            default: "radio"
        },
        size: {
            type: String,
            validator: prop => !!prop && !!prop.match(/^(sm|md|lg)$/i),
            default: "md"
        },
        disabled: {
            type: Boolean,
            default: false
        }
    }
}
</script>
